export const MAP_STYLES: google.maps.MapTypeStyle[] = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#242f3e'
      }
    ]
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#746855'
      }
    ]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#242f3e'
      }
    ]
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  // {
  //   featureType: 'poi',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#d59563'
  //     }
  //   ]
  // },
  // {
  //   featureType: 'poi.park',
  //   elementType: 'geometry',
  //   stylers: [
  //     {
  //       color: '#263c3f'
  //     }
  //   ]
  // },
  // {
  //   featureType: 'poi.park',
  //   elementType: 'labels.text.fill',
  //   stylers: [
  //     {
  //       color: '#6b9a76'
  //     }
  //   ]
  // },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#38414e'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#212a37'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9ca5b3'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#746855'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#1f2835'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#f3d19c'
      }
    ]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#2f3948'
      }
    ]
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#17263c'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#515c6d'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#17263c'
      }
    ]
  }
];

export enum MAP_VERSION {
  WEEKLY = 'weekly',//  Обновляется еженедельно и является самой последней из доступных.
  QUARTERLY = 'quarterly',//  Обновляется ежеквартально и является наиболее стабильной.
  BETA = 'beta',//  Базируется на версии weekly и обновляется еженедельно. Включает изменения, внесенные с целью раннего тестирования и сбора отзывов.
  ALPHA = 'alpha',//  Базируется на версии beta и обновляется еженедельно. Включает эксперименты для получения отзывов клиентов о прототипах. Используется только для целей разработки и не предназначена для рабочей среды.
  VERSION = '3.52',//  Возможные варианты – v=3.52, v=3.51, v=3.50 или v=3.49 (ежеквартальные обновления).
}

export const enum MAP_ZOOM {
  WORLD = 1, // мир
  MIN = 2, // мир без фона
  CONTINENT = 5, // континент
  MAP = 9, // город+окрестности
  CITY = 10, // город
  STREETS = 15, //улицы
  AVATAR = 16, // улицы
  BUILDINGS = 20 // здания
}

export const enum MAP_TYPE {
  ROADMAP = 'roadmap',//  Отображает дороги и многое другое на карте.
  SATELLITE = 'satellite',//  Отображает спутниковые изображения на карте.
  HYBRID = 'hybrid',//  Отображает спутниковые изображения с дорогами на карте.
  TERRAIN = 'terrain'//  Отображает физические характеристики местности, такие как ландшафт и рельеф, на карте.
}
